import {StateUtils} from "@spartacus/core";
import {MULTI_CART_DATA} from "@spartacus/cart/base/core";

export const CART_ADD_SPECIAL_REQUESTS = '[Cart-entry] Add Product Gonvarri';

export class GonvarriCartAddEntry extends StateUtils.EntityProcessesIncrementAction {
  override readonly type = CART_ADD_SPECIAL_REQUESTS;
  constructor(
    public payload: {
      cartId: string;
      userId: string;
      productCode: string;
      quantity: number;
      numberOfSheets: number;
      packageWeight: number;
      isContract: boolean;
      pickupStore?: string;
      length?: number;
    }
  ) {
    super(MULTI_CART_DATA, payload.cartId);
  }
}
